<script lang="ts">
	import SortingArrow from 'components/SortingArrow/SortingArrow.svelte';
	import { _ } from 'utils/i18/i18n';
	import MarketsTableRow from './MarketsTableRow/MarketsTableRow.svelte';
	import type { IFormattedMarket, MarketsSortType } from 'customTypes/exchange';
	import EmptyTable from 'components/EmptyTable/EmptyTable.svelte';
	import PaginationSeo from 'components/PaginationSeo/PaginationSeo.svelte';
	import activeLocale from 'stores/activeLocale';

	$: normalizedLocale = $activeLocale.locale === 'en' ? '' : `/${$activeLocale.locale}/`;

	export let id: string;
	export let tableData: IFormattedMarket[] = [];
	export let dark = false;
	export let filterType: string;
	export let currentPage: number;
	export let totalPages: number;
	export let perPage: number;
	export let sortBy: MarketsSortType;
	export let sortDirection: 'asc' | 'desc';
	export let isLoading: boolean;
	let pressedIconId: string;
	let isPressed = false;

	async function handleFilterClick(
		e: Event & { currentTarget: HTMLElement },
		sortType: MarketsSortType,
		direction: 'asc' | 'desc',
	) {
		pressedIconId = e.currentTarget.id;
		sortBy = sortType;
		sortDirection = direction;
	}
</script>

<div class="wrapper" class:dark>
	<table class="table">
		<thead class="table-head no-select">
			<tr class="table-row">
				<th
					id="filterRank"
					class="head-cell rank clickable"
					on:click={(e) => {
						if (pressedIconId !== 'filterRank') isPressed = true;
						handleFilterClick(e, 'volume', isPressed ? 'asc' : 'desc');
						isPressed = !isPressed;
					}}
					>#<SortingArrow
						{isPressed}
						{pressedIconId}
						idToCompare={'filterRank'}
						width={11}
						height={7}
					/></th
				>
				<th
					id="filterName"
					class="head-cell name clickable"
					on:click={(e) => {
						if (pressedIconId !== 'filterName') isPressed = true;
						handleFilterClick(e, 'name', isPressed ? 'asc' : 'desc');
						isPressed = !isPressed;
					}}
				>
					{$_('exchange.name')}
					<SortingArrow {isPressed} {pressedIconId} idToCompare={'filterName'} width={11} height={7} />
				</th>
				<th class="head-cell pair">{$_('exchange.pair')} </th>
				<th class="head-cell price">{$_('exchange.price')} </th>
				<th class="head-cell depth-plus">
					{#if filterType === 'spot'}
						+2%{$_('exchange.depth')}
					{:else}
						funding rate
					{/if}
				</th>
				<th class="head-cell depth-minus"
					>{#if filterType === 'spot'}
						-2%{$_('exchange.depth')}
					{:else}
						spread
					{/if}</th
				>
				<th class="head-cell volume">{$_('exchange.volume')}</th>
			</tr>
		</thead>
		<tbody class="table-body">
			{#if tableData?.length === 0 || isLoading}
				<EmptyTable
					{dark}
					colAmountFromTabletView={7}
					colAmountMobView={5}
					tableType="exchange-markets"
					withNoDataText={!isLoading}
					withLoadingText={isLoading}
				/>
			{:else}
				{#key tableData}
					{#each tableData as item, i}
						<MarketsTableRow
							{dark}
							data={item}
							{filterType}
							orderNumber={currentPage === 1 ? i + 1 : i + 1 + (currentPage - 1) * perPage}
						/>
					{/each}
				{/key}
			{/if}
		</tbody>
	</table>
</div>

<div class="pagination">
	{#if totalPages}
		<PaginationSeo
			{currentPage}
			linkTo={`/markets/${id}${normalizedLocale}?type=${filterType}&page=`}
			{dark}
			totalCount={totalPages}
		/>
	{/if}
</div>

<style lang="scss">
	@import './marketsTable.scss';
</style>
